<template>
  <div class="row bgs">
    <section-content v-if="$store.state.app.activeGroup.id == 9235 || $store.state.app.activeGroup.id == 9362 || $store.state.app.activeGroup.id == 9368 || $store.state.app.activeGroup.id == 9358" />
    <section-stat v-if="$store.state.app.activeGroup.id == 9235 || $store.state.app.activeGroup.id == 9362 || $store.state.app.activeGroup.id == 9368 || $store.state.app.activeGroup.id == 9358" />
    <section-mission v-if="$store.state.app.activeGroup.id == 9235 || $store.state.app.activeGroup.id == 9368 || $store.state.app.activeGroup.id == 9362 || $store.state.app.activeGroup.id == 9358" />

    

    <div
      v-show="l.active"
      class="col-sm"
      v-for="(l, i) in levels"
      :key="i"
      @click="filterCourses(l)"
      role="button"
    >
      <div :class="`${l.class} rounded-20 pos-relative`">
        <a class="ht-250">
          <div
            class="stars-outer pos-absolute t-0 l-0 wd-100p pd-x-20 pd-t-30 d-flex"
            @click.stop="nextLevel(l, i)"
            style="cursor: e-resize"
          >
            <div v-for="st in 3" :class="`${i + 2 > st ? 'star' : 'star-bish'}`">
              <feather
                type="star"
                style="height: 24px; width: 24px; margin-right: 5px"
              ></feather>
            </div>
          </div>
          <div class="pos-absolute b-0 l-0 wd-100p pd-x-20 pd-b-30">
            <div class="d-flex align-items-center">
              <div class="tx-white">
                <div class="tx-24 font-weight-bold">{{ l.title }}</div>
                <div class="tx-14">{{ l.desc }}</div>
              </div>
              <div
                @click.stop="nextLevel(l, i)"
                class="icn mg-l-auto"
                style="cursor: e-resize"
              >
                <div
                  class="rounded-circle wd-45 ht-45 d-flex align-items-center justify-content-center"
                  style="background: rgba(0, 0, 0, 0.1)"
                >
                  <!-- <feather :type="`arrow-${showRanks?'left':'right'}`" class="tx-white" style="height: 20px; width: 20px"></feather> -->
                  <feather
                    type="mouse-pointer"
                    class="tx-white"
                    style="height: 20px; width: 20px"
                  ></feather>
                </div>
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>
    <div v-show="!showRanks && $store.state.app.activeGroup.id != 9235 && $store.state.app.activeGroup.id != 9368 && $store.state.app.activeGroup.id != 9362 && $store.state.app.activeGroup.id != 9358" class="col-sm mg-t-10 mg-sm-t-0">
      <div class="bg4 rounded-20 pos-relative">
        <router-link
          :to="{
            name: 'lmsCourses',
            params: { md:  ($store.state.app.activeGroup.id == 9241 || $store.state.app.activeGroup.id == 9249) ? 2 : 3, cnm: 'null', type: -1, d1: 'null', d2: 'null' },
          }"
        >
        
        <div style="position: absolute; top: 10px; right: 0; width: 100%; text-align: center; color: white; font-size: 14px; font-weight: bold;">
          {{  moment().format('YYYY оны MM-р сар') }}
        </div>
          <div class="d-flex align-items-center justify-content-center ht-250">
            <vc-donut
              :sections="[
                {
                  value:
                    mustJoinCourses?.currentMonth?.all > 0
                      ? (mustJoinCourses?.currentMonth?.finished * 100) / mustJoinCourses?.currentMonth?.all
                      : 0,
                  color: 'white',
                },
              ]"
              background="#27aef4"
              foreground="#91d4f7"
              :size="150"
              unit="px"
              :thickness="15"
              :total="100"
              :start-angle="-30"
              :auto-adjust-text-size="true"
            >
              <div class="tx-white">
                <div class="tx-20">
                  {{
                    mustJoinCourses?.currentMonth?.all > 0
                      ? ((mustJoinCourses?.currentMonth?.finished * 100) / mustJoinCourses?.currentMonth?.all).toFixed(
                          0
                        )
                      : 0
                  }}%
                </div>
                <div
                  v-if="
                    $store.state.app.activeGroup.id == 9241 ||
                    $store.state.app.activeGroup.id == 9249
                  "
                  class="tx-14 pd-x-20"
                >
                  Заавал үзэх Сургалтын явц
                </div>
                <div v-else class="tx-14 pd-x-20">Сургалтын явц</div>
              </div>
            </vc-donut>
          </div>
          <div
            class="text-right text-white pos-absolute t-0 r-0 wd-100p pd-x-20 pd-t-20 svgwhite"
          >
            <feather
              type="help-circle"
              style="color: white; width: 20px; height: 20px"
            ></feather>
          </div>
          <div class="pos-absolute b-0 l-0 wd-100p pd-x-20 pd-b-20">
            <div class="text-white d-flex">
              <div>
                Нийт: <b>{{ mustJoinCourses?.currentMonth?.all }}</b>
              </div>
              <div class="mg-l-auto">
                Дууссан: <b>{{ mustJoinCourses?.currentMonth?.finished }}</b>
              </div>
            </div>
          </div>
        </router-link>
      </div>
    </div>
    <div v-show="!showRanks && $store.state.app.activeGroup.id != 9235  && $store.state.app.activeGroup.id != 9368 && $store.state.app.activeGroup.id != 9362 && $store.state.app.activeGroup.id != 9358" class="col-sm mg-t-10 mg-sm-t-0">
      <div v-if="$store.state.app.activeGroup.id==9254">
        <iframe v-if="vids.length" style="border-radius: 20px;"
            width="100%"
            height="250"
            :src="`https://www.youtube.com/embed/${vids[0].url}`"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
      </div>
      <div v-else class="bg3 rounded-20 pos-relative" role="button" @click="openVideoTips(true)">
        <div class="icn d-flex ht-250 wd-100p align-items-center justify-content-center">
          <!-- <img src="v4-assets/svgicon/multimedia and audio/outline/play-favourite.svg" class="ht-40 wd-40" /> -->
          <feather
            type="youtube"
            class="tx-white"
            style="height: 40px; width: 40px"
          ></feather>
        </div>
        <div class="text-white pos-absolute b-0 l-0 wd-100p pd-x-20 pd-b-30">
          <div class="tx-20 font-weight-bold">Видео заавар</div>
          <div class="tx-14">Дижитал сургалт үзэх заавар</div>
        </div>
      </div>
    </div>

    <b-modal
      v-model="showVidTipMdl"
      header-class="bd-b-0"
      size="xl"
      content-class="rounded-20 pd-20"
      title="Видео заавар"
      footer-class="bd-t-0"
      hide-footer
      centered
    >
      <!-- <iframe v-if="$store.state.app.activeGroup.id == 9132" width="100%"  height="480"  src="https://www.youtube.com/embed/m9oLjv4hb0k" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            <iframe v-else width="100%"  height="480"  src="https://www.youtube.com/embed/lIe6DmkR0wc" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe> -->
      <!-- {{ vids }} -->

      <Carousel :autoplay="false" type="card" height="480px">
        <Carousel-item v-for="(vid, vi) in vids" :key="vi">
          <!-- <h3 class="medium">{{ item }}</h3> -->
          <iframe
            width="100%"
            height="480"
            :src="`https://www.youtube.com/embed/${vid.url}`"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </Carousel-item>
      </Carousel>
    </b-modal>
  </div>
  <!-- <div class="row">
        <div class="col-sm bg1 ht-200">1</div>
        <div class="col-sm bg1 ht-200">2</div>
        <div class="col-sm bg1 ht-200">3</div>
    </div> -->
  <!-- <div class="bg-gray-200 d-flex justify-content-between mg-b-20">
        <div class="pd-10 bg1 ht-250 wd-250">Flex item 1</div>
        <div class="pd-10 bg1 ht-250 wd-250">Flex item 2</div>
        <div class="pd-10 bg1 ht-250 wd-250">Flex item 3</div>
    </div> -->
</template>
<script>
import { localSave } from "@/libs/util";
import { request } from "@/api/all";
import moment from "moment";

import { getIdFromURL } from "vue-youtube-embed";
import "element-ui/lib/theme-chalk/index.css";
import { Carousel, CarouselItem } from "element-ui";

import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

export default {
  components: {
    Carousel,
    CarouselItem,
    sectionContent: () => ({
      component: import("@/views/modules/lms/student/components/rankContent.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    sectionMission: () => ({
      component: import("@/views/modules/lms/student/components/rankMission.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    sectionStat: () => ({
      component: import("@/views/modules/lms/student/components/rankStat.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  props: {
    mustJoinCourses: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      moment,
      vids: [],
      showRanks: false,
      showVidTipMdl: false,
      sections: [{ value: 25 }],
      levels: [
        // {id: 1, active: true, title: 'Түвшин 1', desc: 'Нийт ажилтнууд ', class: 'bg5'},
        // {id: 2, active: false, title: 'Түвшин 2', desc: 'Мэргэжилтэн, Ахлах, Удирдах ажилтан', class: 'bg6'},
        // {id: 3, active: false, title: 'Түвшин 3', desc: 'Удирдах ажилтан', class: 'bg7'},
      ],
    };
  },
  mounted() {
    if (this.$store.state.app.activeGroup.id == 9132) {
      this.levels = [
        { id: 1, title: "Курс", desc: "Курс ", class: "bg5", active: true },
        { id: 2, title: "Курс", desc: "Курс", class: "bg6", active: false },
        { id: 3, title: "Курс", desc: "Курс", class: "bg7", active: false },
      ];
    } else if (this.$store.state.app.activeGroup.id == 9235  
    || this.$store.state.app.activeGroup.id == 9362 
    || this.$store.state.app.activeGroup.id == 9368 
    || this.$store.state.app.activeGroup.id == 9358) {
      // this.levels=
      // [
      //     {id: -1, title: 'Машинчийн санамж', desc: 'модуль ', class: 'bg7', active: true },
      //     // {id: 2, title: 'Курс', desc: 'Курс', class: 'bg6', active: false },
      //     // {id: 3, title: 'Курс', desc: 'Курс', class: 'bg7', active: false }
      // ];
    }else if(this.$store.state.app.activeGroup.id == 9254){
      this.openVideoTips(false);
    } 
    else {
      this.fillTypes();
    }
  },
  methods: {
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    openVideoTips(modal) {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "type/getData" },
        params: {
          key: "lmsVidTips",
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.vids = res.data.types.map((x) => {
            return {
              url: getIdFromURL(x.s2),
              active: false,
            };
            //x.s2= getIdFromURL(x.s2);
            // console.log(getIdFromURL(x.s2));
          });
          this.$nextTick(() => {
            if (this.vids.length) {
              this.vids[0]["active"] = true;
            }
          });
          if(modal!=undefined && modal==true)
          this.showVidTipMdl = true;
        }
      });
    },
    fillTypes() {
      request({
        api: { url: "type/getData", method: "get" },
        params: { key: "courseLvl", getParentType: true },
        store: this.$store,
      }).then((res) => {
        //console.log("4", res.data.types);
        this.levels = res.data.types.map((x) => {
          return {
            id: x.id,
            active: false,
            title: x.s2,
            desc: x.s1,
            class: x.s3,
          };
        });
        if (this.levels.length) {
          this.levels[0]["active"] = true;
        }
      });
    },
    filterCourses(l) {
      if (l.id == -1) {
        this.$router.push({
          name: "lmsSanamj",
          params: { id: 0, cid: 0, title: "Машинчийн санамж" },
        });
      } else {
        localSave("course_filter_lc2_dta", JSON.stringify(this.levels));
        localSave("course_filter_lc2", l.id);
        this.$router.push({
          name: "lmsCourses",
          params: { md: 1, cnm: "null", type: -1, d1: "null", d2: "null" },
        });
      }
    },
    // getLevelActiveIndex(l){

    // },
    nextLevel(l, indx) {
      let self = this;
      this.levels.forEach((el) => (el.active = false));
      this.$nextTick(() => {
        if (self.levels.length - 1 == indx) {
          self.levels[0]["active"] = true;
        } else {
          self.levels[indx + 1]["active"] = true;
        }
      });
    },
  },
};
</script>
<style>
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
</style>
